class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);


 (function () {
    if (customElements.get('cart-recommendations-slider')) return;

    class CartRecommendationsSlider extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.startX = 0;
        this.currentTranslate = 0;
        this.prevTranslate = 0;
        this.isDragging = false;
        this.hasDragged = false; // true only once real movement is detected
        this.slideWidth = 0;
        this.dragThreshold = 6; // px of movement before we treat this as a drag, not a tap

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);
        this.onResize = this.onResize.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('.slider-viewport');
        this.track = this.querySelector('.slider-track');
        this.slides = Array.from(this.querySelectorAll('.slider-slide'));
        this.dots = Array.from(this.querySelectorAll('.slider-dot'));

        if (!this.track || this.slides.length === 0) return;

        this.slideWidth = this.viewport.getBoundingClientRect().width;

        // Pointer / drag events (covers mouse + touch)
        this.track.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);

        // Block navigation only when a real drag happened, so taps on
        // product links / Add to Cart still work normally.
        this.track.addEventListener('click', this.onClickCapture, true);

        // Prevent native image/link drag ghosting
        this.track.addEventListener('dragstart', (e) => e.preventDefault());

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.index, 10);
            this.goToSlide(index);
          });
        });

        window.addEventListener('resize', this.onResize);

        this.goToSlide(0, false);
      }

      disconnectedCallback() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        if (this.track) {
          this.track.removeEventListener('click', this.onClickCapture, true);
        }
      }

      onResize() {
        this.slideWidth = this.viewport.getBoundingClientRect().width;
        this.goToSlide(this.currentIndex, false);
      }

      onPointerDown(e) {
        // Only left mouse button / primary touch point
        if (e.button !== undefined && e.button !== 0) return;

        this.isDragging = true;
        this.hasDragged = false;
        this.startX = e.clientX;
        this.prevTranslate = -this.currentIndex * this.slideWidth;
        this.track.classList.add('is-dragging');
        // NOTE: intentionally NOT calling setPointerCapture here — capturing
        // the pointer on the track redirects the resulting click event to
        // the track itself, which stops <a> links inside slides (product
        // title, Add to Cart) from ever receiving/firing their click.
      }

      onPointerMove(e) {
        if (!this.isDragging) return;
        const deltaX = e.clientX - this.startX;

        if (!this.hasDragged && Math.abs(deltaX) > this.dragThreshold) {
          this.hasDragged = true;
        }

        if (this.hasDragged) {
          this.currentTranslate = this.prevTranslate + deltaX;
          this.track.style.transform = `translateX(${this.currentTranslate}px)`;
        }
      }

      onPointerUp(e) {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.classList.remove('is-dragging');

        if (!this.hasDragged) {
          // It was a tap/click, not a drag — let the click event through
          // untouched so links navigate normally.
          return;
        }

        const deltaX = (e.clientX || this.startX) - this.startX;
        const threshold = this.slideWidth * 0.2;

        if (deltaX < -threshold && this.currentIndex < this.slides.length - 1) {
          this.currentIndex += 1;
        } else if (deltaX > threshold && this.currentIndex > 0) {
          this.currentIndex -= 1;
        }

        this.goToSlide(this.currentIndex);
      }

      onClickCapture(e) {
        // If the pointerdown->pointerup sequence was a real drag, swallow
        // the click so it doesn't also trigger link navigation. Reset the
        // flag immediately after so the *next* tap works normally.
        if (this.hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          this.hasDragged = false;
        }
      }

      goToSlide(index, animate = true) {
        index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.currentIndex = index;
        this.setAttribute('data-index', String(index));

        if (!animate) {
          this.track.style.transition = 'none';
        }

        this.track.style.transform = `translateX(${-index * this.slideWidth}px)`;

        if (!animate) {
          // force reflow, then restore transition
          void this.track.offsetHeight;
          this.track.style.transition = '';
        }

        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    }

    customElements.define('cart-recommendations-slider', CartRecommendationsSlider);
  })();

  

  (function () {
  if (customElements.get('selling-plan-toggle')) return;

  class SellingPlanToggle extends HTMLElement {
    static CART_SECTIONS = [
      'cart-data',
      'cart-drawer',
      'cart-drawer-notification'
    ];

    connectedCallback() {
      this.button = this.querySelector('.selling-plan-toggle__button');
      this.label = this.querySelector('.selling-plan-toggle__label');

      if (!this.button) return;

      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.onClick);
      }
    }

    get key() {
      return this.dataset.key;
    }

    get variantId() {
      return this.dataset.variantId;
    }

    get quantity() {
      return parseInt(this.closest("tr").querySelector(".quantiy_selector_part input").value, 10) || 1;
    }

    get currentSellingPlanId() {
      return this.dataset.sellingPlanId || '';
    }

    get availablePlanId() {
      return this.dataset.availablePlanId || '';
    }

    get changeUpgrade() {
      return (this.dataset.changeUpgrade || '').trim();
    }

    get addUrl() {
      return this.dataset.addUrl || '/cart/add.js';
    }

    get changeUrl() {
      return this.dataset.changeUrl || '/cart/change.js';
    }

    async onClick() {
      if (this.button.disabled) return;

      const isSubscription = this.changeUpgrade === 'subscription';

      console.log('Selling Plan Toggle:', {
        key: this.key,
        variantId: this.variantId,
        quantity: this.quantity,
        currentSellingPlanId: this.currentSellingPlanId,
        availablePlanId: this.availablePlanId,
        changeUpgrade: this.changeUpgrade,
        isSubscription
      });

      // Subscription upgrade requires a selling plan ID
      if (isSubscription && !this.availablePlanId) {
        console.error(
          'selling-plan-toggle: no selling plan ID available'
        );
        return;
      }

      this.setLoading(true);

      try {
        /*
         * STEP 1
         * Remove the existing cart line.
         *
         * We must do this first because we're replacing the
         * current one-time line with a subscription line.
         */
        await this.changeLineItem(0);

        /*
         * STEP 2
         * Add the variant back.
         *
         * IMPORTANT:
         * /cart/add.js requires variant ID,
         * NOT cart line key.
         */
        const item = {
          id: Number(this.variantId),
          quantity: this.quantity
        };

        /*
         * Upgrade:
         * Add selling plan.
         */
        if (isSubscription) {
          item.selling_plan = Number(this.availablePlanId);
        }

        const formData = {
          items: [item],
          sections: SellingPlanToggle.CART_SECTIONS,
          sections_url: window.location.pathname
        };

        console.log('Adding cart item:', formData);

        const addResponse = await fetch(this.addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(formData)
        });

        const responseBody = await addResponse
          .json()
          .catch(() => ({}));

        console.log('Cart add response:', responseBody);

        if (!addResponse.ok) {
          throw new Error(
            responseBody.description ||
            responseBody.message ||
            'Failed to add item'
          );
        }

        /*
         * /cart/add.js returns:
         *
         * {
         *   items: [...]
         * }
         */
        const addedItem = Array.isArray(responseBody.items)
          ? responseBody.items[0]
          : null;

        if (!addedItem) {
          throw new Error(
            'Add request succeeded but no item was returned'
          );
        }

        /*
         * Update this element's internal state.
         */
        this.syncStateFrom(addedItem);

        /*
         * Tell the theme that cart changed.
         */
        document.dispatchEvent(
          new CustomEvent('Themu:cart:add', {
            bubbles: true,
            detail: responseBody.sections
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              source: 'selling-plan-toggle',
              item: addedItem,
              sections: responseBody.sections || {}
            }
          })
        );

      } catch (error) {
        console.error(
          'selling-plan-toggle:',
          error
        );

        this.dispatchCartError(error);

      } finally {
        this.setLoading(false);
      }
    }

    /*
     * Remove/change existing cart line.
     */
    async changeLineItem(quantity) {
      const response = await fetch(this.changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: this.key,
          quantity: Number(quantity)
        })
      });

      const responseBody = await response
        .json()
        .catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          responseBody.description ||
          responseBody.message ||
          'Failed to change cart item'
        );
      }

      return responseBody;
    }

    syncStateFrom(addedItem) {
      this.dataset.key = addedItem.key;
      this.dataset.quantity = addedItem.quantity;

      this.dataset.sellingPlanId =
        addedItem.selling_plan_allocation
          ? addedItem.selling_plan_allocation.selling_plan.id
          : '';

      /*
       * After upgrading:
       * subscription -> show downgrade button
       *
       * After downgrading:
       * one-time -> show upgrade button
       */
      if (addedItem.selling_plan_allocation) {
        this.dataset.changeUpgrade = 'onetime';

        this.label.textContent =
          'Downgrade to one-time purchase';
      } else {
        this.dataset.changeUpgrade = 'subscription';

        this.label.textContent =
          'Upgrade to subscription';
      }
    }

    setLoading(isLoading) {
      this.button.disabled = isLoading;

      this.button.classList.toggle(
        'is-loading',
        isLoading
      );
    }

    dispatchCartError(error) {
      document.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            source: 'selling-plan-toggle',
            error
          }
        })
      );
    }
  }

  customElements.define(
    'selling-plan-toggle',
    SellingPlanToggle
  );
})();



(function () {
  if (customElements.get('selling-plan-selector')) return;

  class SellingPlanSelector extends HTMLElement {

     static CART_SECTIONS = [
      'cart-data',
      'cart-drawer',
      'cart-drawer-notification'
    ];

    connectedCallback() {
        
      this.select = this.querySelector('.selling_plan__ids');

      if (!this.select) return;

      this.onChange = this.onChange.bind(this);

      this.select.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      if (this.select) {
        this.select.removeEventListener('change', this.onChange);
      }
    }

    get key() {
      return this.dataset.key;
    }

    get variantId() {
      return Number(this.dataset.variantId);
    }

    get quantity() {
      return Number(this.closest("tr").querySelector(".quantiy_selector_part input").value) || 1;
    }

    async onChange(event) {
  const select = event.target;
  const sellingPlanId = select.value;

  console.log('Selected Selling Plan:', sellingPlanId);
  console.log('Selected Option:', select.selectedOptions[0]?.textContent.trim());

      if (!this.key || !sellingPlanId) {
        console.error('Missing cart key or selling plan ID');
        return;
      }

      this.setLoading(true);

      try {


         const item = {
          id: this.key,
          quantity: this.quantity,
          selling_plan: Number(sellingPlanId)
        };

         const formData = {
       id: this.key,
          quantity: this.quantity,
          selling_plan: Number(sellingPlanId),
          sections:     SellingPlanSelector.CART_SECTIONS,
          sections_url: window.location.pathname
        };
console.log("formData" , formData)
        const addResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body:  JSON.stringify(formData)
        });

        const addBody = await addResponse.json();

        if (!addResponse.ok) {
          throw new Error(
            addBody.description ||
            addBody.message ||
            'Failed to add new selling plan'
          );
        }

        console.log('New item added:', addBody);

        /*
         * 3. Update new cart key
         */
        const newItem = addBody.items?.[0];

        if (newItem) {
          this.dataset.key = newItem.key;
          this.dataset.quantity = newItem.quantity;
        }

        document.dispatchEvent(
          new CustomEvent('Themu:cart:add', {
            bubbles: true,
            detail: addBody.sections
          })
        );

        /*
         * 4. Notify cart drawer/theme
         */
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              source: 'selling-plan-selector',
              item: newItem,
              cart: addBody
            }
          })
        );

      } catch (error) {
        console.error(
          'Selling plan update error:',
          error
        );

      } finally {
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      if (this.select) {
        this.select.disabled = loading;
      }

      this.classList.toggle(
        'is-loading',
        loading
      );
    }
  }

  customElements.define(
    'selling-plan-selector',
    SellingPlanSelector
  );
})();